// extracted by mini-css-extract-plugin
module.exports = {"noImperfectionsTab":"_3JakL","noImperfectionsText":"_1A5w-"};